import permissions from '../../permissions'

const PRIVACY_BY_DESIGN_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.VISUALIZE,
    tag: permissions.PRIVACY_BY_DESIGN.LIST,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.PRIVACY_BY_DESIGN.MANAGE,
  },
]

export default PRIVACY_BY_DESIGN_LIST
